import { render, staticRenderFns } from "./ElPaslaugaSantrauka.vue?vue&type=template&id=066b4f18&scoped=true&"
import script from "./ElPaslaugaSantrauka.vue?vue&type=script&lang=js&"
export * from "./ElPaslaugaSantrauka.vue?vue&type=script&lang=js&"
import style0 from "./ElPaslaugaSantrauka.vue?vue&type=style&index=0&id=066b4f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066b4f18",
  null
  
)

export default component.exports